const updateFitErrors = (state, { payload: { errors } }) => {
	state.errors = errors;
};

export default updateFitErrors;
